import { render, staticRenderFns } from "./SkuChoosePrice.vue?vue&type=template&id=2564681d&scoped=true&"
import script from "./SkuChoosePrice.vue?vue&type=script&lang=js&"
export * from "./SkuChoosePrice.vue?vue&type=script&lang=js&"
import style0 from "./SkuChoosePrice.vue?vue&type=style&index=0&id=2564681d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564681d",
  null
  
)

export default component.exports